export default "__VITE_ASSET__DU7UUFb5__"